export default __webpack_public_path__ + "static/media/logo-asana.5c9ced4f.svg";